// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393270273864",
  numero_telefono: "tel:+390813503322",

  canShowPagamentoRate: false,
  textShowPagamentoRate: "",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',

  */

  urlWeb: 'https://discentya.istitutofondazionedoria.it/',
  urlMaterialeDidattico: 'https://discentya.istitutofondazionedoria.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.istitutofondazionedoria.it/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.istitutofondazionedoria.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.istitutofondazionedoria.it/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.istitutofondazionedoria.it/api/',

  urlStampa: 'https://discentya.istitutofondazionedoria.it/stampe/',

  urlAttestati: 'https://discentya.istitutofondazionedoria.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.istitutofondazionedoria.it/pages/certificate/',
  urlImagePartners: 'https://discentya.istitutofondazionedoria.it/assets/media/partners/',
  urlImageMedia: 'https://discentya.istitutofondazionedoria.it/assets/media/',
};
